import PersonalInfoModule, {
  PersonalInfoModuleProps,
} from './PersonalInfoModule';

export type {PersonalInfoModuleProps};

export default PersonalInfoModule;
